/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidatorEscrowEventRequest
 */
export interface ValidatorEscrowEventRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidatorEscrowEventRequest
     */
    address: string;
    /**
     * 
     * @type {number}
     * @memberof ValidatorEscrowEventRequest
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ValidatorEscrowEventRequest
     */
    size: number;
}

export function ValidatorEscrowEventRequestFromJSON(json: any): ValidatorEscrowEventRequest {
    return ValidatorEscrowEventRequestFromJSONTyped(json, false);
}

export function ValidatorEscrowEventRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorEscrowEventRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'page': json['page'],
        'size': json['size'],
    };
}

export function ValidatorEscrowEventRequestToJSON(value?: ValidatorEscrowEventRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'page': value.page,
        'size': value.size,
    };
}


